// 权限管理
import http from '@/jslibs/axios/http';

// 登录
export const login = data => http.post('/web/login/login', data);

// 获取当前用户信息
export const getInfo = () => http.post('/web/permissionManager/getAccountInfo');
